/* ------------------------------------------------------------------------ */
/*		File: App.tsx                                                       */
/*		Description: App function                                           */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './scss/tailwind.css';
import './i18n/config';
import Home from './pages/Home/Home';
import AboutUs from "./pages/About/About";
import NavbarHeader from './pages/NavbarHeader/NavbarHeader';
import Courses from './pages/Courses/Courses';
import HowItWorks from './pages/HowItWorks/HowItWorks';
import ApplyNow from './pages/ApplyNow/ApplyNow';
import BlogsAndNews from './pages/BlogsAndNews/BlogsAndNews';
import Login from './pages/Login/Login';
import DetailCourse from './pages/DetailCourse/DetailCourse';
import Plans from './pages/Plans/Plans';
import DetailResource from './pages/BlogsAndNews/DetailResource';
import Footer from './pages/Footer/Footer';
import Thankyou from './pages/Thankyou/Thankyou';
import Prospectus from './pages/Prospectus/Prospectus';
import ScrollToTop from './components/GenericComponents/scroll';
import { getPromocodes } from './api/hooks';
import Chatbot from './components/cmpChatBot/cmpChatBot';
import Spinner from './components/GenericComponents/spinner';
import { ChatbotProvider } from './context/ChatbotContext';
import { initGA, logPageView } from './api/analytics';


/* ------------------------------------------------------------------------ */

const App: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        initGA();
        logPageView();
        const script = document.createElement('script');
        if (process.env.NODE_ENV === 'production') {
            script.id = "cookieyes";
            script.type = "text/javascript";
            script.src = "https://cdn-cookieyes.com/client_data/aff9f4c393087c1297bd427c/script.js";
            script.async = true;

            // Manejo de errores durante la carga del script
            script.onerror = () => {
                console.error("Error loading the CookieYes script.");
            };

            document.head.appendChild(script);
        }

        let didFetch = false;

        const checkPromos = async () => {
            if (didFetch) return; // Evita una segunda llamada innecesaria
            didFetch = true;
            try {
                const response: any = await getPromocodes()
                if (response!.msg === "OK") {
                    window.localStorage.setItem("hasPromocode", response!.hasPromocode);
                    window.localStorage.setItem("campaign", response.campaign)
                } else {
                    window.localStorage.setItem("hasPromocode", "false");
                    window.localStorage.setItem("campaign", "null")
                }

            } catch (error) {
                console.error("Error fetching promo codes:", error);
            }
        }

        checkPromos();
        const timeout = setTimeout(() => {
            setIsLoading(false);
        }, 1500)

        return () => {
            if (process.env.NODE_ENV === 'production') {
                document.head.removeChild(script);
            }
        };
    }, []);


    return (
        <ChatbotProvider>
            <HelmetProvider>
                <Router>
                    {isLoading  
                        ? (<Spinner
                            isLoading={isLoading}
                            type='initial'
                        />
                        ) : (
                            <>
                                <ScrollToTop />
                                <NavbarHeader />

                                <Routes>
                                    <Route path="/" element={<Home />} />
                                    <Route path="/Home" element={<Home />} />
                                    <Route path="/AboutUs" element={<AboutUs />} />
                                    <Route path="/Courses" element={<Courses />} />
                                    <Route path="/Courses/:courseId" element={<DetailCourse />} />
                                    <Route path="/HowItWorks" element={<HowItWorks />} />
                                    <Route path="/ApplyNow/:webId?" element={<ApplyNow />} />
                                    <Route path="/Resources/:criteria?" element={<BlogsAndNews />} />
                                    <Route path="/Resources/detail/:id" element={<DetailResource />} />
                                    <Route path="/login" element={<Login />} />
                                    <Route path="/Plans/:id?" element={<Plans />} />
                                    <Route path="/Thankyou" element={<Thankyou />} />
                                    <Route path="/Prospectus" element={<Prospectus />} />
                                </Routes>
                                <Chatbot />
                                <Footer />
                            </>
                        )
                    }
                </Router>
            </HelmetProvider>
        </ChatbotProvider>
    );
};

export default App;
